import { render, staticRenderFns } from "./ExpenditureCompensationRequest.vue?vue&type=template&id=5df21041&scoped=true"
import script from "./ExpenditureCompensationRequest.vue?vue&type=script&lang=js"
export * from "./ExpenditureCompensationRequest.vue?vue&type=script&lang=js"
import style0 from "./ExpenditureCompensationRequest.vue?vue&type=style&index=0&id=5df21041&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df21041",
  null
  
)

export default component.exports